module.exports = __webpack_public_path__ + "static/img/03.889f60a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/03.png
// module id = nptT
// module chunks = 0